<template>
  <div class="space-y-6">
    <fiscal-data-component></fiscal-data-component>
    <bank-account-component></bank-account-component>
  </div>
</template>

<script>
import FiscalDataComponent from "@/views/MyAccount/BillingPayments/FiscalDataComponent";
import BankAccountComponent from "@/views/profile/BankAccountComponent";

export default {
  name: "BillingPaymentsComponent",
  components: {
    FiscalDataComponent,
    BankAccountComponent
  }
}
</script>

<style scoped>

</style>
